var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_525_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#EDF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6078 30.3755C27.4294 30.3755 28.4958 29.9534 28.4958 28.5817V19.4548C28.4958 18.3452 28.0016 17.6533 27.3642 17.1532L21.9256 12.8851C21.1742 12.2954 20.6915 12.0273 19.9998 12.0273C19.3082 12.0273 18.8255 12.2953 18.0741 12.8851L12.6355 17.1532C11.9981 17.6533 11.5039 18.3452 11.5039 19.4548V28.5817C11.5039 29.9536 12.5703 30.3755 13.3919 30.3755H19.9998H26.6078Z",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 22.2637C19.0112 22.2637 18.2148 23.061 18.2148 24.0508V30.3749H21.7849V24.0508C21.7849 23.061 20.9887 22.2637 19.9999 22.2637Z",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_525_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.74cc3987bfe09581efe1866aaffd67c3.svg";
export { ForwardRef as ReactComponent };